import { MusicGameCharacter } from "GameObjects/MusicGame/Character";

export class MusicGameHolly extends MusicGameCharacter {

    protected animations = {
        idle: "Idle",
        idleToReady: "Getting Ready To Play",
        ready: "Ready To Play",
        playing: "Playing",
    };

    constructor(pData: {id: number}) {
        super({name: 'holly', skeleton: 'Holly Front Rig', ...pData});
        this.playAnimation(this.animations.idle);
        this._spine.update(0);
    }

}